import React from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { TableTurnLogo } from '../brand/Logo';
import { FiGrid, FiList, FiUsers, FiSettings, FiMessageSquare, FiInfo, FiHelpCircle } from 'react-icons/fi';

const NavItem = ({ to, icon, label }) => (
  <NavLink
    to={to}
    className={({ isActive }) => `
      flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 group
      ${isActive 
        ? 'bg-chiliRed/10 text-chiliRed border border-chiliRed/20 shadow-glow-red' 
        : 'text-receiptMuted hover:text-receiptWhite hover:bg-chefPanel/50'
      }
    `}
  >
    <SafeIcon icon={icon} className="w-5 h-5 flex-shrink-0 group-hover:scale-110 transition-transform" />
    <span className="font-mono text-[10px] uppercase tracking-widest hidden md:block whitespace-nowrap">{label}</span>
  </NavLink>
);

export const Sidebar = () => {
  return (
    <aside className="w-16 md:w-64 bg-chefBlack border-r border-chefPanel flex flex-col h-screen fixed left-0 top-0 z-20">
      <div className="h-20 flex items-center px-4 border-b border-chefPanel/50">
        <div className="flex items-center gap-3">
          <TableTurnLogo size="md" />
          <div className="hidden md:flex flex-col leading-none">
            <span className="text-receiptWhite font-mono font-bold text-lg tracking-tighter">TABLE<span className="text-chiliRed">TURN</span></span>
            <span className="text-[8px] text-chiliRed font-mono uppercase tracking-[0.2em] mt-0.5">Ops Command</span>
          </div>
        </div>
      </div>
      
      <nav className="flex-1 py-8 px-3 space-y-1 overflow-y-auto custom-scrollbar">
        <div className="text-[9px] text-receiptMuted font-mono uppercase mb-4 px-4 hidden md:block tracking-[0.3em] opacity-50">Operations</div>
        <NavItem to="/" icon={FiGrid} label="Command Center" />
        <NavItem to="/how-it-works" icon={FiInfo} label="System Specs" />
        <NavItem to="/prep" icon={FiList} label="Prep Lanes" />
        <NavItem to="/staff" icon={FiUsers} label="Personnel" />
        
        <div className="text-[9px] text-receiptMuted font-mono uppercase mt-10 mb-4 px-4 hidden md:block tracking-[0.3em] opacity-50">Intelligence</div>
        <NavItem to="/feedback" icon={FiMessageSquare} label="Guest Insights" />
        <NavItem to="/faq" icon={FiHelpCircle} label="Tech Support" />
      </nav>

      <div className="p-4 border-t border-chefPanel/50 bg-chefDark/30">
        <NavItem to="/settings" icon={FiSettings} label="Core Config" />
      </div>
    </aside>
  );
};